/**
 * nb-cloud-model-picker
 *
 * Switches between a configured set of products when a different model button is chosen. Rendered
 * by snippets/nb-cloud-model-picker.liquid as a `cloud_model_picker` main-product block (pill
 * buttons); the models are configured in the theme editor.
 *
 * Each button is a radio carrying its target product handle in data-handle. This script listens for
 * the radio `change`:
 * - on a PDP it navigates to that product — a plain full-page load, preserving any locale prefix;
 * - inside a quick-add modal it reloads the modal with that product instead (see quick-add.js).
 *
 * The listener is delegated from the document because quick-add modal content is injected after
 * page load, and guarded because that injection re-runs this script.
 */
(function () {
  if (window.__nbCloudModelPickerInit) return;
  window.__nbCloudModelPickerInit = true;

  document.addEventListener('change', function (event) {
    const option = event.target;
    if (!option.matches || !option.matches('[data-cloud-model-picker] input[data-handle]')) return;

    const handle = option.dataset.handle;
    if (!handle) return;

    const quickAddModal = option.closest('quick-add-modal');
    if (quickAddModal && typeof quickAddModal.loadProduct === 'function') {
      const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      const picker = option.closest('[data-cloud-model-picker]');
      picker.disabled = true;
      quickAddModal.loadProduct(root + 'products/' + handle).catch(function () {
        picker.disabled = false;
      });
      return;
    }

    // Replace the handle segment after `/products/` so any locale prefix (e.g. /en-gb/) is kept.
    const segments = window.location.pathname.split('/');
    const productsIndex = segments.indexOf('products');
    if (productsIndex === -1 || productsIndex + 1 >= segments.length) return;
    if (segments[productsIndex + 1] === handle) return; // already on this model

    segments[productsIndex + 1] = handle;
    window.location.href = segments.join('/');
  });
})();
